import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import {
  Box,
  ClickAwayListener,
  Fade,
  Grow,
  Paper,
  Popper,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import LocationToggler from "../../LocationToggler";
import { CustomTab, CustomTabs } from "../../Tabs/CustomTabs";
import Avatar from "../Avatar";

import actions from "../../../Stores/Auth/actions";

import { displayName, validateBoolItem } from "../../../utils/helpers";
import PolicySearchCard from "../../Policy/PolicySearchCard";
import { useStyles } from "./style";
import MenuIndicators from "../../Indicators/MenuIndicator";
import MenuIcons from "../../../Assets/Menu/MenuIcons";
import { CcTooltip } from "../../../design-system/carecentre";

const logoutAction = actions.logout;

const UserHeader = ({
  hasTab,
  paths,
  location,
  showProfileTabs,
  profileTabs,
  profileLocation,
  showLocationToggle,
  title,
  onLocationChange,
  showSearch,
  showWelcomeMessage,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.AuthReducer.user);
  const userName = displayName(userInfo);
  const { activeLocation } = useSelector(
    (state) => state.SlickCareProfilesReducer,
  );
  const menuIndicators = useSelector(
    (state) => state.AuthReducer.menuIndicators,
  );

  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [greeting, setGreeting] = React.useState("");

  const date = new Date();
  let hours = date.getHours();

  useEffect(() => {
    let text = "Good Morning";
    if (hours) {
      if (hours < 12) {
        text = "Good Morning";
      } else if (hours < 17) {
        text = "Good Afternoon";
      } else {
        text = "Good Evening";
      }
    }
    setGreeting(text);
  }, [hours]);

  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Box className={classes.wrap}>
        <Box className={classes.wrapContent}>
          {showWelcomeMessage && (
            <Fade in timeout={800}>
              <Box className={classes.welcomeSection}>
                <Typography className={classes.welcomeTitle}>
                  Welcome back, {userName}! 👋
                </Typography>
                <Typography className={classes.welcomeSubtitle}>
                  Here's what's happening at {activeLocation?.title} today
                </Typography>
              </Box>
            </Fade>
          )}
          <Box className={classes.userRoutes}>
            {showProfileTabs && showProfileTabs === true && (
              <Box>
                <CustomTabs
                  value={profileLocation?.pathname}
                  onChange={() => {}}
                  textColor="primary"
                  variant="scrollable"
                >
                  {profileTabs.map((path, index) => {
                    let canRender = false;
                    let component = <></>;

                    if (path?.requires_check) {
                      canRender = validateBoolItem(
                        path,
                        userInfo,
                        userInfo?.accounting_type,
                      );
                    } else {
                      canRender = true;
                    }

                    if (canRender) {
                      component = (
                        <CustomTab
                          component={Link}
                          to={
                            profileTabs[index].path_to_go
                              ? profileTabs[index].path_to_go
                              : profileTabs[index].path
                          }
                          value={
                            profileTabs[index].path_to_match
                              ? profileTabs[index].path_to_match
                              : profileTabs[index].path
                          }
                          label={
                            <Box
                              display="flex"
                              alignItems="center"
                              style={{ gap: 6 }}
                            >
                              {path.title}
                              <MenuIndicators
                                indicators={path?.indicators ?? []}
                                menuIndicators={menuIndicators}
                              />
                            </Box>
                          }
                        />
                      );
                    }

                    return component;
                  })}
                </CustomTabs>
              </Box>
            )}
            {hasTab && hasTab === true && (
              <Box>
                <CustomTabs
                  value={location?.pathname}
                  onChange={() => {}}
                  textColor="primary"
                >
                  {paths.map((path, index) => (
                    <CustomTab
                      component={Link}
                      to={paths[index].path}
                      value={paths[index].path}
                      label={path.title}
                    />
                  ))}
                </CustomTabs>
              </Box>
            )}
          </Box>
          {showSearch && <PolicySearchCard />}
          <Box className={classes.userInfo}>
            {showLocationToggle && (
              <LocationToggler
                history={history}
                onLocationChange={onLocationChange}
              />
            )}
            <CcTooltip title="My Feedbacks" placement="bottom">
              <Box
                onClick={() => history.push("/d/feedback/mine")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
              >
                <MenuIcons.MenuFeedback width="20px" height="20px" />
              </Box>
            </CcTooltip>
            <Box
              className={classes.userBadge}
              onClick={handleToggle}
              ref={anchorRef}
            >
              <Avatar />
            </Box>
          </Box>
        </Box>
      </Box>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        disablePortal={false}
        role={undefined}
        transition
        style={{
          zIndex: theme.zIndex.modal,
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className={classes.popperContent}>
              <h4 className={classes.poperHeader}>
                {greeting},
                <span className={classes.poperSubHeader}>
                  {" "}
                  {userInfo?.id ? userInfo?.name : `~`}
                </span>
              </h4>
              <Box className={classes.userData}>
                <Typography className={classes.email}>
                  {userInfo?.id ? userInfo?.email : "~"}
                </Typography>
              </Box>
              <div className={classes.divider}></div>

              <ClickAwayListener onClickAway={handleClose}>
                <ul className={classes.list}>
                  <li
                    className={classes.listLink}
                    onClick={() => {
                      history.push("/d/myprofile");
                    }}
                  >
                    Profile
                  </li>
                  <li
                    className={classes.listLink}
                    onClick={() => {
                      history.push("/d/myprofile/notification-settings");
                    }}
                  >
                    Notification Settings
                  </li>
                  <li
                    className={classes.listLink}
                    onClick={() => {
                      dispatch(logoutAction(history));
                    }}
                  >
                    Logout
                  </li>
                </ul>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default memo(UserHeader);
